import React, { lazy, Suspense } from "react";

// This is a lazy loaded component that loads the CSS slate styles for the page as the native-styles.css break homepage prefetching

export const LazyNativeStyles: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <LazyNativeBase />
    </Suspense>
  );
};

const LazyNativeBase = lazy<React.ComponentType>(() =>
  import(/* webpackChunkName: "native-styles" */ "./NativeStyles").then(
    (module) => {
      return {
        default: module.NativeStyles,
      };
    }
  )
);
